var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenFilledArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 10C20.5 4.47715 16.0228 6.78525e-07 10.5 4.37114e-07C4.97715 1.95703e-07 0.500001 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20C16.0228 20 20.5 15.5228 20.5 10ZM6.5 9.25C6.08579 9.25 5.75 9.58579 5.75 10C5.75 10.4142 6.08579 10.75 6.5 10.75L13.4362 10.75C13.4251 10.7642 13.4137 10.7787 13.4018 10.7935C13.1427 11.1161 12.7573 11.4997 12.1824 12.0695L10.772 13.4673C10.4778 13.7589 10.4757 14.2338 10.7673 14.528C11.0589 14.8222 11.5338 14.8243 11.828 14.5327L13.2691 13.1043C13.8053 12.573 14.2525 12.1298 14.5713 11.7328C14.9057 11.3163 15.1601 10.8787 15.2281 10.3455C15.2427 10.2308 15.25 10.1154 15.25 10C15.25 9.8846 15.2427 9.76921 15.2281 9.65451C15.1601 9.12131 14.9057 8.68367 14.5713 8.26724C14.2525 7.87022 13.8053 7.42704 13.2691 6.89566L11.828 5.46731C11.5338 5.17573 11.0589 5.17784 10.7673 5.47204C10.4757 5.76624 10.4778 6.24111 10.772 6.53269L12.1824 7.93054C12.7573 8.50033 13.1427 8.88386 13.4018 9.20649C13.4137 9.22128 13.4251 9.23579 13.4362 9.25L6.5 9.25Z",
    fill: "url(#paint0_linear_3319_2285)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3319_2285",
    x1: 10.5,
    y1: 20,
    x2: 10.5,
    y2: 4.37114e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FAC6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFilledArrow);
export default __webpack_public_path__ + "static/media/green-filled-arrow.4b782b4abdf72a83ac27704b8a0277c5.svg";
export { ForwardRef as ReactComponent };